// Texty výpisu kategorie a detailu značky (categoryPage.js). Doprava/vrácení
// v perks poradny sdílí znění s dalšími poradnami napříč šablonou.
import { plural } from '../plural.js';

export default {
  filterTitle: 'Filtrace',
  clearAll: 'Vymazat vše',
  availability: 'Dostupnost',
  tags: 'Štítky',
  seoTitle: 'Vše, co potřebujete vědět',
  /** „O značce X" (detail značky, blok bez vlastního H2) */
  seoBrand: (name) => 'O značce ' + name,
  seoAnchor: 'více o výběru níže',

  // Top produkty v kategorii (restyl nativního bloku „Nejprodávanější")
  topTitle: (name) => (name ? 'Top produkty v kategorii ' + name : 'Top produkty v kategorii'),
  topFlag: 'Nejprodávanější #1',

  // Sekce filtru nad SEC_LIMIT položek
  secMore: (n) => 'Zobrazit více (' + n + ')',
  secLess: 'Zobrazit méně',

  // Přepínač perexu na mobilu
  perexMore: 'Zobrazit celý popis',
  perexLess: 'Zobrazit méně',

  // Prázdné stavy
  noResultTitle: 'Zvolenému filtru neodpovídá žádný produkt',
  noResultText: 'Zkuste rozšířit cenové rozpětí nebo zrušit některý z filtrů.',
  noResultCta: 'Zrušit filtry',
  emptyTitle: 'V této kategorii teď nic nemáme',
  emptyTextSub: 'Produkty jsou zařazené v podkategoriích výše, vyberte si z nich.',
  emptyText: 'Zkuste se podívat do nadřazené sekce nebo použijte vyhledávání.',

  // Panel poradny (§7)
  advice: {
    eyebrow: 'Poradna Jipos',
    title: 'Nevíte si rady s výběrem?',
    text: 'Zavolejte nám nebo napište, poradíme s výběrem i příslušenstvím.',
    textNoPhone: 'Napište nám, poradíme s výběrem i příslušenstvím.',
    callLabel: 'Poradíme s výběrem',
    storeLabel: 'Navštívit prodejnu',
    perkShipping: 'Doprava po celé ČR',
    perkReturn: 'Vrácení zboží do 14 dní',
    perkService: 'Servis nářadí na prodejně',
  },

  // Promo karta ve mřížce (§15) — výchozí Slevoakce
  promo: {
    eyebrow: 'Slevoakce',
    title: 'Nářadí a technika ve slevě',
    body: 'Všechny aktuálně zlevněné produkty přehledně na jednom místě.',
    cta: 'Zobrazit slevy',
  },

  /** 1 produkt / 2–4 produkty / 5+ produktů */
  productsWord: (n) => plural(n, ['produkt', 'produkty', 'produktů']),
};
